import React from 'react';
import { Icon } from './WeatherIcon.styles';

// Icons
import iconClearSky from '../../assets/images/icons/weather/01d.png';
import iconFewClouds from '../../assets/images/icons/weather/02d.png';
import iconScatteredClouds from '../../assets/images/icons/weather/03d.png';
import iconBrokenClouds from '../../assets/images/icons/weather/04d.png';
import iconShowerRain from '../../assets/images/icons/weather/09d.png';
import iconRain from '../../assets/images/icons/weather/10d.png';
import iconThunderstorm from '../../assets/images/icons/weather/11d.png';
import iconSnow from '../../assets/images/icons/weather/13d.png';
import iconMist from '../../assets/images/icons/weather/50d.png';
import iconUnknown from '../../assets/images/icons/weather/unknown.png';

const WeatherIcon = ({ type }) => {
  switch (type) {
    case '01d':
    case '01n':
      return <Icon src={iconClearSky} />;
    case '02d':
    case '02n':
      return <Icon src={iconFewClouds} />;
    case '03d':
    case '03n':
      return <Icon src={iconScatteredClouds} />;
    case '04d':
    case '04n':
      return <Icon src={iconBrokenClouds} />;
    case '09d':
    case '09n':
      return <Icon src={iconShowerRain} />;
    case '10d':
    case '10n':
      return <Icon src={iconRain} />;
    case '11d':
    case '11n':
      return <Icon src={iconThunderstorm} />;
    case '13d':
    case '13n':
      return <Icon src={iconSnow} />;
    case '50d':
    case '50n':
      return <Icon src={iconMist} />;
    default:
      return <Icon src={iconUnknown} />;
  }
};

export default WeatherIcon;
